import { TELEGRAM_URL } from '../config/media';
import { PRICES_CARDS, PRICES_MAIN } from '../config/prices';
import { PriceUnit } from '../modules';

function PricesPage() {
  return (
    <main className="w-full">
      <PriceUnit variant="main" {...PRICES_MAIN} telegramUrl={TELEGRAM_URL} />

      <div className="mt-16 grid grid-cols-1 gap-12 md:mt-20 md:grid-cols-2 md:gap-x-10 md:gap-y-16">
        {PRICES_CARDS.map((card) => (
          <PriceUnit key={`${card.category}-${card.title}`} variant="card" {...card} telegramUrl={TELEGRAM_URL} />
        ))}
      </div>
    </main>
  );
}

export default PricesPage;
